import { gql } from "@apollo/client";

export default gql`
  fragment TagFields on Tag {
    _id
    slug
    name
  }
`;
